import styled from 'styled-components';
import { Layout, Flex } from 'antd';
import { colors, fonts, sizes, breakpoints } from '../../theme';

const { Footer: AntFooter } = Layout;

export const StyledFooter = styled(AntFooter)`
  position: relative;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${colors.blackTransparent[60]};
  backdrop-filter: blur(8px);
  padding: ${sizes.padding.lg} 0;

  &::before {
    content: '';
    position: absolute;
    top: -40px;
    left: 0;
    right: 0;
    height: 40px;
    background: linear-gradient(to bottom, transparent 0%, ${colors.blackTransparent[20]} 25%, ${colors.blackTransparent[40]} 50%, ${colors.blackTransparent[60]} 100%);
  }

  ${breakpoints.media.mobile} {
    padding: ${sizes.padding.md} 0;
  }
`;

export const FooterContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${sizes.gap.lg};
  max-width: ${sizes.layout.maxWidth};
  margin: ${sizes.margin.auto};
  padding: 0 ${sizes.padding.lg};
  position: relative;

  ${breakpoints.media.mobile} {
    padding: 0 ${sizes.padding.sm};
    gap: ${sizes.gap.md};
    text-align: center;
  }
`;

export const StyledFlex = styled(Flex)`
  width: 100%;
  justify-content: center;
  align-items: center;
  position: relative;
  gap: 0;
  flex-direction: row;

  ${breakpoints.media.mobile} {
    flex-direction: column;
    gap: ${sizes.gap.md};
  }
`;

export const FooterCreature = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 2;

  ${breakpoints.media.mobile} {
    justify-content: center;
  }
`;

export const FooterCreatureImg = styled.img`
  height: 213px;
  width: auto;

  ${breakpoints.media.mobile} {
    height: 140px;
  }
`;

export const FooterContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${sizes.gap.xs};
  padding: ${sizes.padding.sm} 4rem;
  border: 2px solid ${colors.primary};
  border-radius: ${sizes.borderRadius.medium};
  background: ${colors.blackTransparent[50]};
  backdrop-filter: blur(8px);
  position: relative;
  z-index: 1;
  min-width: 480px;
  width: auto;
  margin-left: -150px;

  ${breakpoints.media.mobile} {
    min-width: auto;
    width: 100%;
    max-width: 320px;
    margin: 0 auto;
    padding: ${sizes.padding.xs} ${sizes.padding.md};
  }
`;

export const FooterContactText = styled.h3`
  color: ${colors.white};
  font-family: ${fonts.families.primary};
  font-size: ${fonts.sizes.lg};
  font-weight: ${fonts.weights.bold};
  margin: 0;
  text-transform: ${fonts.textTransform.uppercase};
  letter-spacing: ${fonts.letterSpacing.wide};
  text-shadow: 0 0 ${sizes.pixels.small} ${colors.whiteTransparent[50]};
  display: flex;
  align-items: center;
  gap: ${sizes.gap.sm};
  justify-content: center;

  ${breakpoints.media.mobile} {
    font-size: ${fonts.sizes.md};
  }
`;

export const FooterEmail = styled.a`
  color: ${colors.white};
  font-family: ${fonts.families.secondary};
  font-size: ${fonts.sizes.md};
  font-weight: ${fonts.weights.normal};
  text-decoration: none;
  transition: all 0.3s ease;
  padding: ${sizes.padding.sm} ${sizes.padding.md};
  background: ${colors.blackTransparent[30]};
  backdrop-filter: blur(4px);
  border-radius: ${sizes.borderRadius.small};
  text-align: center;

  &:hover {
    color: ${colors.white};
    background: ${colors.primaryTransparent[25]};
    text-shadow: 0 0 ${sizes.pixels.medium} ${colors.primaryTransparent[50]};
    transform: translateY(-2px);
    box-shadow: 0 4px 12px ${colors.primaryTransparent[30]};
  }

  &:focus {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }

  ${breakpoints.media.mobile} {
    font-size: ${fonts.sizes.sm};
    padding: ${sizes.padding.xs} ${sizes.padding.sm};
  }
`;

export const FooterCopyright = styled.p`
  color: ${colors.whiteTransparent[70]};
  font-family: ${fonts.families.secondary};
  font-size: ${fonts.sizes.sm};
  font-weight: ${fonts.weights.normal};
  margin: ${sizes.margin.md} 0 0 0;
  line-height: ${fonts.lineHeight.normal};
  text-align: center;

  ${breakpoints.media.mobile} {
    font-size: ${fonts.sizes.xs};
    margin-top: ${sizes.margin.md};
  }
`;